// extracted by mini-css-extract-plugin
export default {"Emojify":"bbn_a bhn_g"};